module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-item",
    attrs: {
      "id": _vm.id
    },
    on: {
      "click": _vm.click
    }
  }, [_c('div', {
    staticClass: "card-item__inner"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCard),
      expression: "isCard"
    }],
    staticClass: "card-face front",
    domProps: {
      "innerHTML": _vm._s(_vm.cardItemText)
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "card-face back",
    class: _vm.selectedSpecialCard ? 'active' : ''
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedSpecialCard),
      expression: "selectedSpecialCard"
    }],
    staticClass: "card-special-title"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/txt_crispr_cas_small.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _vm._l((_vm.cardItemData), function(item, index) {
    return _c('li', {
      class: index
    }, [(item !== '') ? _c('span', [_vm._v(_vm._s(_vm.textDNA[index]))]) : _vm._e(), _vm._v(" "), (item !== '') ? _c('span', [_vm._v(_vm._s(item))]) : _vm._e()])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3836938a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardItem.vue
// module id = 75
// module chunks = 0